import { createSlice } from "@reduxjs/toolkit";

import { fetchPhoneDirectoryListData } from "../thunks/phoneDirectoryThunks";

import type { PhoneDirectory } from "../../utils/types/phoneDirectory";

interface PhoneDirectoryState {
  phoneDirectory: PhoneDirectory[];
  total: number;
  loading: boolean;
  error: string | null;
}

const initialState: PhoneDirectoryState = {
  phoneDirectory: [],
  total: 0,
  loading: false,
  error: null,
};

export const phoneDirectorySlice = createSlice({
  name: "phoneDirectory",
  initialState,
  reducers: {
    clearPhoneDirectory: (state) => {
      state.phoneDirectory = [];
      state.total = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPhoneDirectoryListData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPhoneDirectoryListData.fulfilled, (state, action) => {
        state.phoneDirectory = action.payload.data || [];
        state.total = action.payload.total || 0;
        state.loading = false;
      })
      .addCase(fetchPhoneDirectoryListData.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
  },
});

export const { clearPhoneDirectory } = phoneDirectorySlice.actions;

export default phoneDirectorySlice.reducer;
